<form [formGroup]="formGroup" style="height: 100%" >
<div #container class="ocl-container-with-padding" fxLayout="column" [style.max-height]="maxHeight" >
    <div #controls style="margin-bottom: 16px">
        <app-loading-header [loading]="false">Additional Copies</app-loading-header>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between" style="height: 21px">
            <div class="dx-field" style="width: 25% !important;">
                <div class="dx-field-value" style="width: 100% !important;">
                    <dx-select-box [dataSource]="['EMAIL', 'FAX']"
                                   placeholder="Type"
                                   formControlName="typeControl"
                    ></dx-select-box>
                </div>
            </div>
            <div class="dx-field" style="width: 50% !important;">
                <div *ngIf="IsEmail; then emailBlock else faxBox" class="dx-field-value" style="width: 100% !important;"></div>
            </div>
            <ng-template #emailBlock>
              <dx-text-box  formControlName="destinationControl" (onEnterKey)="add()">
                <dx-validator validationGroup="emailValidationGroup" >
                  <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </ng-template>
          <ng-template #faxBox>
            <dx-text-box mask="000-000-0000" formControlName="destinationControl" maskInvalidMessage="Fax is invalid" (onEnterKey)="add()">
              <dx-validator validationGroup="faxValidationGroup" >
                <dxi-validation-rule type="pattern" [pattern]="faxPattern"
                                     message="Fax is invalid"></dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </ng-template>
            <div class="button-group">
               <!-- <dx-tooltip target="#addBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
                    <div *dxTemplate="let data of 'content'">
                        <p>Add</p>
                    </div>
                </dx-tooltip>
                <dx-tooltip target="#removeBtn" showEvent="dxhoverstart" hideEvent="dxhoverend">
                    <div *dxTemplate="let data of 'content'">
                        <p>Remove</p>
                    </div>
                </dx-tooltip>-->

                <dx-button
                    id="addBtn"
                    [icon]="'add'"
                    [disabled]="formGroup.invalid"
                    [title]="'Add'"
                    [hint]="'Add'"
                    (onClick)="add()"
                    style="height: 24px; margin-right: 4px;margin-left: 4px;"
                ></dx-button>
                <dx-button
                    id="removeBtn"
                    hint='Remove'
                    [disabled]="selectedKeys.length === 0"
                    [icon]="'trash'"
                    title="Remove"
                    (onClick)="remove()"
                    style="height: 24px; margin-right: 4px;"
                ></dx-button>
            </div>
        </div>
    </div>
    <dx-data-grid
        [height]="gridHeight"
        [showBorders]="true"
        [showColumnLines]="true"
        [showRowLines]="true"
        [hoverStateEnabled]="true"
        [dataSource]="additionalCopiesControl.value"
        [(selectedRowKeys)]="selectedKeys"
        [allowColumnResizing]="true"
        (onContentReady)="refresh()"
    >
        <dxi-column dataField="destination" caption="Destination"></dxi-column>
        <dxi-column dataField="type" caption="Type"></dxi-column>
        <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
    </dx-data-grid>
</div>
</form>
